import request from "../request";

export const getClasses = (curriculumId, filter) =>
  request.post(`/assessment/${curriculumId}/classes/list`, { filter }).then((res) => res);

export const getClassesSkipLimit = (curriculumId, skip = 0, limit = 5, filter) =>
  request.post(`/assessment/${curriculumId}/classes/list/skip/${skip}/limit/${limit}`, { filter }).then((res) => res);

export const getClassById = (curriculumId, id) =>
  request.get(`/assessment/${curriculumId}/classes/${id}`).then((res) => res);

export const getUnitOfLearningsClassById = (curriculumId, classId, ulId) =>
  request.get(`/assessment/${curriculumId}/classes/${classId}/unit-of-learning/${ulId}`).then((res) => res);

export const createClass = (curriculumId, data) =>
  request.post(`/assessment/${curriculumId}/classes`, data).then((res) => res);

export const cloneClass = (curriculumId, id) =>
  request.post(`/assessment/${curriculumId}/classes/${id}/clone`).then((res) => res);

export const updateClass = (curriculumId, id, type, data) =>
  request.put(`/assessment/${curriculumId}/classes/${id}/${type}`, data).then((res) => res);

export const archiveClass = (curriculumId, id) =>
  request.delete(`/assessment/${curriculumId}/classes/${id}/archive`).then((res) => res);

export const deleteClass = (curriculumId, id) =>
  request.delete(`/assessment/${curriculumId}/classes/${id}`).then((res) => res);

export const batchUpdateClasses = (curriculumId, type, data) =>
  request.put(`/assessment/${curriculumId}/classes/batch/${type}`, data).then((res) => res);